import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from '../../styles/LessonView.module.css';
function pluralize(n, one, few, many) {
    const abs = Math.abs(n);
    const mod10 = abs % 10;
    const mod100 = abs % 100;
    if (mod10 === 1 && mod100 !== 11)
        return one;
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20))
        return few;
    return many;
}
export function ResultTable({ result, maxRows = 100 }) {
    if (result.columns.length === 0) {
        return _jsx("div", { className: styles.emptyResult, children: "\u0417\u0430\u043F\u0440\u043E\u0441 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D, \u043D\u043E \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u043F\u0443\u0441\u0442\u043E\u0439." });
    }
    const displayRows = result.rows.slice(0, maxRows);
    const truncated = result.rows.length > maxRows;
    return (_jsxs("div", { children: [_jsxs("table", { className: styles.resultTable, children: [_jsx("thead", { children: _jsx("tr", { children: result.columns.map((col, i) => (_jsx("th", { children: col }, i))) }) }), _jsx("tbody", { children: displayRows.map((row, i) => (_jsx("tr", { children: row.map((val, j) => (_jsx("td", { children: val === null ? 'NULL' : String(val) }, j))) }, i))) })] }), _jsxs("div", { className: styles.rowCount, children: [result.rows.length, " ", pluralize(result.rows.length, 'строка', 'строки', 'строк'), truncated && ` (показано ${maxRows})`] })] }));
}
